import React, { useState } from 'react'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from 'react-router-dom';
import SortOutlinedIcon from '@mui/icons-material/SortOutlined';
import { blue, red } from '@mui/material/colors';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 10,
  p: 3,
};
function MobileUpcomingEvents() {
  const navigate = useNavigate();
  // const handleDateClick = (arg) => {
  //   alert(arg.dateStr)
  // }
  const events = [
    { title: 'Meeting Test Test', start: new Date() }
  ]
  const [eventShowHide, setEventShowHide] = useState();
  const handleShowEvent = () => {
    setEventShowHide(true);
  }

  function renderEventContent(eventInfo) {
    return (
      <div className='CalenderEventView' onClick={handleShowEvent}>
        <b>{eventInfo.timeText}</b>
        <i>{eventInfo.event.title}</i>
      </div>
    )
  }
  const [open, setOpen] = useState(false);
  const handleOpen = () => {setOpen(true)};
  const handleClose = () => { setOpen(false) };
  const [vehicleType, setVehicleType] = React.useState('');
    const handleChange = (event) => {
        setVehicleType(event.target.value);
      };
  return (
    <div className='mainwrapperView'>
    <div className="drawerWithTop">
        {/* <MobileDrawer /> */}
        <ArrowBackIcon
        className="backArrowMobil"
        onClick={() => navigate("/Apartment")}
        />
        <h1>Events</h1>
    </div>
    <div className='topSpace'></div>
    <div className='SearchSortDiv'>
        <input type='text' placeholder='Search' />
        <SortOutlinedIcon sx={{fontSize:30, color: blue[800]}} />
    </div>
      <FullCalendar
      plugins={[ dayGridPlugin ]}
      
      initialView="dayGridMonth"
      events={events}
      eventContent={renderEventContent}
    />
      {eventShowHide ? <div className='ListingView'>
        <div className="famDetailsListInrMob">
        <div className='EventBoxView'>
        <p className='EventTitleTxt'>Test Event</p>
          <div className='EventTimeView'>
            <p className='EventVenueTxt'>Venue: </p>
            <p className='EventAddressTxt'>Panchawati, Nashik</p>
          </div>
          <div className='EventTimeView'>
            <p className='EventVenueTxt'>Time: </p>
            <p className='EventAddressTxt'>05/08/2024 11:20 am</p>
          </div>
          <div className='EventReminderBtnView' onClick={handleOpen}>
            <NotificationsActiveIcon sx={{fontSize:18, color:'#db1f1f'}} />
            <p className='EventReminderTxt'>Reminder</p>
          </div>
          </div>
        </div>
      </div> : null}
      <div className='flaotBtnAdd'>
        <Fab onClick={()=>navigate('/MobileAddEvent')} size="medium" sx={{backgroundColor: '#3853ec'}} aria-label="add" >
          <AddIcon sx={{fontSize: 32, color:'white'}}/>
        </Fab>
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className='modalTitleView'>
            <p className='modalTitleTxt'>Reminder</p>
            <CloseIcon sx={{ color: red[600], fontSize: 25 }} onClick={handleClose} />
          </div>
            <div className='FormView'>
            <div className='lebalInputView'>
            <p className='inputLebal'>Select Reminder Time</p>
            <Select
              value={vehicleType}
              onChange={handleChange}
              displayEmpty
              inputProps={{ 'aria-label': 'Without label' }}
              >
              <MenuItem value="">
                  <em>None</em>
              </MenuItem>
              <MenuItem value={'one'}>1 hr</MenuItem>
              <MenuItem value={'two'}>2 hr</MenuItem>
              <MenuItem value={'three'}>3 hr</MenuItem>
            </Select>
            </div>
            <button className='submitButton' type='submit'>Set Reminder</button>
            </div>
        </Box>
      </Modal>
    </div>
  )
}

export default MobileUpcomingEvents